webpackJsonp([35783957827783],{

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Baidu = function (_React$Component) {
	  _inherits(Baidu, _React$Component);
	
	  function Baidu() {
	    _classCallCheck(this, Baidu);
	
	    return _possibleConstructorReturn(this, (Baidu.__proto__ || Object.getPrototypeOf(Baidu)).apply(this, arguments));
	  }
	
	  _createClass(Baidu, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "adsbybaidu" },
	        "TODO"
	      );
	    }
	  }]);
	
	  return Baidu;
	}(_react2.default.Component);
	
	exports.default = Baidu;
	;

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Google = function (_React$Component) {
	  _inherits(Google, _React$Component);
	
	  function Google() {
	    _classCallCheck(this, Google);
	
	    return _possibleConstructorReturn(this, (Google.__proto__ || Object.getPrototypeOf(Google)).apply(this, arguments));
	  }
	
	  _createClass(Google, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (window) (window.adsbygoogle = window.adsbygoogle || []).push({});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('ins', { className: this.props.className + ' adsbygoogle',
	        style: this.props.style,
	        'data-ad-client': this.props.client,
	        'data-ad-slot': this.props.slot,
	        'data-ad-layout': this.props.layout,
	        'data-ad-format': this.props.format,
	        'data-full-width-responsive': this.props.responsive });
	    }
	  }]);
	
	  return Google;
	}(_react2.default.Component);
	
	exports.default = Google;
	;
	
	Google.propTypes = {
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object, // eslint-disable-line
	  client: _propTypes2.default.string.isRequired,
	  slot: _propTypes2.default.string.isRequired,
	  layout: _propTypes2.default.string,
	  format: _propTypes2.default.string,
	  responsive: _propTypes2.default.string
	};
	
	Google.defaultProps = {
	  className: '',
	  style: { display: 'block' },
	  format: 'auto',
	  layout: '',
	  responsive: 'false'
	};

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _google = __webpack_require__(805);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _baidu = __webpack_require__(804);
	
	var _baidu2 = _interopRequireDefault(_baidu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdSense = {
	  Google: _google2.default,
	  Baidu: _baidu2.default
	};
	
	exports.default = AdSense;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(32);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAdsense = __webpack_require__(806);
	
	var _reactAdsense2 = _interopRequireDefault(_reactAdsense);
	
	var _Masonary = __webpack_require__(251);
	
	var _Masonary2 = _interopRequireDefault(_Masonary);
	
	var _store = __webpack_require__(30);
	
	var _shared = __webpack_require__(44);
	
	var _Seo = __webpack_require__(110);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Main = __webpack_require__(84);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(109);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  return {
	    showcase: {}
	  };
	};
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Index);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.featureNavigator = _shared.featureNavigator.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Index.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.navigatorPosition !== "is-featured") {
	      this.props.setNavigatorPosition("is-featured");
	    }
	  };
	
	  Index.prototype.componentDidMount = function componentDidMount() {
	    var script = document.createElement("script");
	
	    script.src = "//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=519fc41f-0653-4509-90ef-924c14ee1371";
	    script.async = true;
	
	    document.body.appendChild(script);
	  };
	
	  Index.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        classes = _props.classes;
	
	    var facebook = (((data || {}).site || {}).siteMetadata || {}).facebook;
	
	    return _react2.default.createElement(
	      _Main2.default,
	      null,
	      _react2.default.createElement(
	        _Article2.default,
	        null,
	        _react2.default.createElement("div", { id: "amzn-assoc-ad-519fc41f-0653-4509-90ef-924c14ee1371" }),
	        _react2.default.createElement(_Seo2.default, { facebook: facebook }),
	        _react2.default.createElement(_Masonary2.default, {
	          className: classes.showcase,
	          products: data.allProduct.edges.map(function (edge) {
	            return edge.node;
	          })
	        })
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  setNavigatorPosition: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    isWideScreen: state.isWideScreen
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(Index));
	
	//eslint-disable-next-line no-undef
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-31800b092855b932707a.js